import React from 'react';
import { siteInfo, socialLinks, logoUrl } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#080706] py-8 md:py-12 px-4 md:px-6 overflow-hidden">
      <div className="container mx-auto max-w-4xl">
        {/* Divider */}
        <div className="flex items-center justify-center mb-8">
          <div className="flex-1 h-[1px] bg-gradient-to-r from-transparent to-[#8B7355]/20" />
          <div className="mx-4 w-1.5 h-1.5 rotate-45 bg-[#D4A853]/30" />
          <div className="flex-1 h-[1px] bg-gradient-to-l from-transparent to-[#8B7355]/20" />
        </div>

        {/* Logo */}
        <div className="text-center mb-6">
          <img 
            src={logoUrl} 
            alt="Mistress T-Rex Monroe" 
            className="h-28 md:h-36 lg:h-40 w-auto mx-auto mb-4"
          />
          <p className="text-[#8B7355] text-sm tracking-[0.2em] uppercase mt-2">
            {siteInfo.tagline} • {siteInfo.location}
          </p>
        </div>

        {/* Social Links */}
        <div className="flex justify-center gap-6 mb-8">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#8B7355]/60 text-xs tracking-[0.2em] uppercase hover:text-[#D4A853] transition-colors"
            >
              {social.name}
            </a>
          ))}
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-[#8B7355]/40 text-xs tracking-wider">
            © {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
          <p className="text-[#8B7355]/30 text-xs tracking-wider mt-2">
            All sessions are consensual and legal. 18+ only.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
